'use strict';

var dom = require('../utils/dom.js');

/**
 * Quickly know where your code will be executed
 */
function useSsr() {
    return {
        isBrowser: dom.isBrowser,
        isServer: !dom.isBrowser,
    };
}

exports.useSsr = useSsr;
//# sourceMappingURL=useSsr.js.map
